import { configuratorActions } from './configurator-slice';
import config from './config';
import { getCsrfToken } from './config';
import { getSourceCode } from './config';
import moment from "moment";
import { current } from '@reduxjs/toolkit';

export const fetchConfiguratorData = (defaultConfiguratorState) => {
  return async (dispatch) => {
    const fetchData = async () => {
      let searchFilter = "";
      if(config.settings.massType != null) {
        searchFilter = "?filter=" + config.settings.massType;
      }
      let url = config.settings.apiEndpoint + 'api/requests/GetRequestDefaults/' + config.settings.productCollection + searchFilter;
      if(config.settings.cartItemId) {
        url = config.settings.apiEndpoint + 'api/requests/GetRequestDefaults/' + config.settings.productCollection + '/' + config.settings.cartItemId + searchFilter;
      }

      const response = await fetch(
        url,
        {
          method: 'GET',
          credentials: "include",
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          }
        }
      );

      if (!response.ok) {
        throw new Error('Could not fetch configurator data!');
      }

      const data = await response.json();

      return data;
    };

    try {
      const configuratorData = await fetchData();
      //console.log('configurator data loaded');
      dispatch(
        configuratorActions.setInitialState({
            pageDefaults: defaultConfiguratorState,
            request: configuratorData
        })
      );
    } catch (error) {
      console.log(error);
      alert(error);
    }
  };
};

export const sendCartData = (currentCart, currentPreview, currentProduct) => {

  let cartQty = 1;
  let cartPrice = (currentCart.OfferingAmount) ? parseFloat(currentCart.OfferingAmount) : 0;
  if(config.settings.massType === 'individual') {
    cartQty = Number(currentCart.MassQuantity);
    cartPrice = cartPrice / cartQty;
  }

  let cardSendItem = {
    Id: currentCart.Id,
    SkuId: currentProduct.SKUID,
    Quantity: cartQty, // if individual
    Price: cartPrice,
    CustomData: []
  };
  if(currentCart.Id) {
    cardSendItem.Id = Number(currentCart.Id);
  }

  // set donor request fields related to cart
  currentCart.ProductID = currentProduct.SKUID;
  currentCart.CurrentProductID = currentProduct.SKUID;
  currentCart.CurrentProduct = currentProduct.SKUNumber;
  currentCart.OccasionLabel = currentPreview.Occasion.Description;
  currentCart.Purpose = currentPreview.Occasion.PortfolioPurposeCode;
  currentCart.CurrentPurpose = currentPreview.Occasion.PortfolioPurposeCode;
  if(currentCart.MassDate) currentCart.MassDate = moment(currentCart.MassDate).format('L');
  if(currentCart.DateOfDeath) currentCart.DateOfDeath = moment(currentCart.DateOfDeath).format('L');

  if(currentCart.CardTypeValue === 'nocard') {
    currentCart.Card = '';
    currentCart.CardID = 0;
    currentCart.CardDescription = '';
    currentCart.CardImage = '';
    currentCart.CardQuantity = 0;
    currentCart.VerseID = 0;
    currentCart.Verse = '';
    currentCart.CustomVerseInput = '';
    currentCart.MailDate = '';
    currentCart.EcardData = '';
    currentCart.EcardEmail = '';
    currentCart.EcardName = '';
    currentCart.EcardProductTitle = '';
    currentCart.EcardCustomVerse = '';
    currentCart.EcardIntention = '';
    currentCart.EcardMassDate = '';
    currentCart.EcardMassDateHeader = '';
    currentCart.EcardServiceLineMultiple = '';
    currentCart.EcardServiceLineSingle = '';
    currentCart.EcardSignAsLines = '';
    currentCart.CurrentShippingPrice = 0;
  } else {
    currentCart.Card = currentPreview.SelectedCard.PictureCode; //PortfolioPictureCode
    currentCart.CardID = currentPreview.SelectedCard.Id;
    currentCart.CardDescription = currentPreview.SelectedCard.Description;
    currentCart.CardImage = currentPreview.SelectedCard.CoverImage; //CoverImage
    // currentCart.CardQuantity = 0; <-- for seasonal cards
    currentCart.VerseID = currentPreview.SelectedVerse.Id;
    currentCart.Verse = currentPreview.SelectedVerse.VerseCode; // PortfolioVerseCode
    currentCart.CustomVerseInput = currentPreview.CustomVerse;
    if(currentCart.MailDate) currentCart.MailDate = moment(currentCart.MailDate).format('L');

    // ecard info
    if(currentCart.CardTypeValue === 'ecard') {
      const ecardData = {
          CoverImage: currentPreview.SelectedCard.CoverImage,
          InsideImage: currentPreview.SelectedCard.InsideImage,
          VerseImage: currentPreview.SelectedVerse.VerseImage,
          ServiceLineSingle: "",
          ServiceLineMultiple: currentPreview.CardHeading,
          Intention: currentCart.Intention,
          DateHeader: "",
          MassDate: currentCart.MassDate,
          SignAsLines: currentCart.CardSignature,
          CustomVerse: currentCart.CustomVerseInput,
          Product: config.settings.productCollection
      };
      currentCart.EcardData = ecardData;
      currentCart.EcardProductTitle = currentProduct.EcardProductTitle;
    } 

    // CurrentShippingPrice
  }

  if(!currentCart.Id) {
    currentCart.SourceCode = getSourceCode();
  }
  // for donations
  // Honoree
  //HonoreeCaption
  
  for(const i in currentCart) {
    cardSendItem.CustomData.push({
      Name: i,
      Value: currentCart[i] 
    });
  }

  let addOrUpdateEndpoint = 'api/requests/AddItem';
  if(cardSendItem.Id) {
    addOrUpdateEndpoint = 'api/requests/UpdateItem';
  }

  return async (dispatch) => {
    const sendRequest = async () => {
      const response = await fetch(
        config.settings.apiEndpoint + addOrUpdateEndpoint,
        {
          method: 'POST',
          credentials: "include",
          body: JSON.stringify(cardSendItem),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.AntiForgeryToken
          }
        }
      );

      if (!response.ok) {
        throw new Error('Sending cart data failed.');
      }

      const data = await response.json();

      if(addOrUpdateEndpoint.indexOf('AddItem') > -1) {
        const cartItemElement = document.querySelector('.cartlink span');
        if(cartItemElement) {
          let cartItemCount = Number(cartItemElement.textContent);
          cartItemCount++;
          cartItemElement.textContent = cartItemCount;
        } else {
          const span = document.createElement("span");
          const node = document.createTextNode("1");
          span.appendChild(node);
          const cartLink = document.querySelector('.cartlink');
          if(cartLink) {
            cartLink.appendChild(span);
          }
        }
      }

      return data;
    };

    try {

      const cartItemData = await sendRequest();
      dispatch(configuratorActions.setApprove(cartItemData.Id));

    } catch (error) {
      console.log(error);
    }
  };
};